import { createContext, useContext } from "react";
import useContactForm from "../useContactForm";

// create the context
const EmailContext = createContext()

// create a custo hook
export const useEmail = () => useContext(EmailContext)

// export the provider
export default function EmailProvider({ children }) {
    
    // import the functions and states from the useContact custom form hook
    const {
        handleChange,
        form,
        handleSubmit,
        submitted,
        errors
    } = useContactForm()

    return (
        <EmailContext.Provider
            value={{
                handleChange,
                form,
                handleSubmit,
                submitted,
                errors
            }}
        >
            { children }
        </EmailContext.Provider>
    )
}